import React from "react";
import ManufacturedDevices from "../../device/ManufacturedDevices";
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";

const ManufacturedDevicesPage = () => {
  return (
    <ResponsiveContentWrapper>
      <ManufacturedDevices />
    </ResponsiveContentWrapper>
  );
};

export default ManufacturedDevicesPage;
